import { type Common } from './common.js';
import type {
  AssignmentGroup,
  AssignmentGroupBasic,
  AssignmentGroupQueryParams,
  BaseAssignmentGroup,
} from './models/assignmentGroup/assignmentGroup.js';

export class API {
  common: Common;
  baseEndpoint = '/assignment-groups';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: AssignmentGroupQueryParams): Promise<AssignmentGroup[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findAllBasic(queryParams?: AssignmentGroupQueryParams): Promise<AssignmentGroupBasic[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/basic`, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(assignmentGroupId: string): Promise<AssignmentGroup> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${assignmentGroupId}`);
    return await this.common.getJSON(url);
  }

  async findOneByIdBasic(assignmentGroupId: string): Promise<AssignmentGroupBasic> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${assignmentGroupId}/basic`);
    return await this.common.getJSON(url);
  }

  async create(values: Omit<BaseAssignmentGroup, 'state'>): Promise<AssignmentGroup> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: Partial<Pick<BaseAssignmentGroup, 'name' | 'description' | 'state'>>
  ): Promise<AssignmentGroup> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async delete(id: string): Promise<AssignmentGroup> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
